module.exports = __webpack_public_path__ + "assets/img/vip.c92b953d.png";